import styled from 'styled-components'

export const Container = styled.div`
  display: block;
  max-width: 500px;

  .col1 {
    padding-right: 10px;
  }

  .col1,
  .col2 {
    width: 50%;
    float: left;
    box-sizing: border-box;
  }

  .form-controls {
    height: 34px;
    border: 1px solid #ddd;
    border-radius: 0;
    padding: 5px;
    margin-bottom: 10px;
    box-sizing: border-box;
    font-size: 16px;
  }

  .form-controls:focus {
    outline: none;
    border-color: #00a9e0;
  }

  .firstdata-field-focused,
  .focus {
    outline: none;
    border-color: #00a9e0;
  }

  .firstdata-field-invalid,
  .invalid {
    color: #c01324;
    border-color: #c01324;
  }

  .firstdata-field-valid,
  .valid {
    border-color: #43b02a;
  }

  label.focus,
  label.valid,
  label.invalid {
    border: none;
  }
`

export const Grid = styled.div`
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(1px, 1fr));
  grid-gap: 20px;
`

export const Form = styled.form`
  position: relative;
`
